// @flow

import * as React from 'react';
import { FormSubmitButtons as CompoundComponents } from './form_submit_buttons/compound_components';

type Props = {
  cancelLinkProps?: {
    className?: string,
  },
  cancelText: string,
  children?: React.Node,
  compact: boolean,
  disabled: boolean,
  fancy: boolean,
  hideCancelButton: boolean,
  isSubmitting: boolean,
  onCancel?: () => void,
  onSubmit: (SyntheticEvent<HTMLButtonElement>) => void,
  submitText: string,
  cancelComponent?: ?React.Element<*>,
};

const FormSubmitButtons = (props: Props) => {
  function cancel(event: SyntheticEvent<HTMLButtonElement>) {
    event.preventDefault();

    if (props.onCancel) {
      props.onCancel();
    }
  }

  function renderCancel() {
    const {
      cancelLinkProps,
      cancelText,
      cancelComponent,
      hideCancelButton,
    } = props;

    if (cancelComponent) {
      return React.cloneElement(cancelComponent, {
        onClick: cancel,
      });
    } else if (!hideCancelButton) {
      return (
        <CompoundComponents.Cancel
          onCancel={props.onCancel}
          {...cancelLinkProps}
        >
          {cancelText}
        </CompoundComponents.Cancel>
      );
    } else {
      return null;
    }
  }

  const { children, compact, onSubmit, submitText, ...otherProps } = props;

  return (
    <CompoundComponents.Row compact={compact} extraAction={children}>
      {renderCancel()}
      <CompoundComponents.Submit onClick={onSubmit} {...otherProps}>
        {submitText}
      </CompoundComponents.Submit>
    </CompoundComponents.Row>
  );
};

FormSubmitButtons.defaultProps = {
  cancelLinkProps: {},
  cancelText: 'Cancel',
  compact: false,
  fancy: false,
  hideCancelButton: false,
  isSubmitting: false,
  size: 'default',
  submitText: 'Save',
  disabled: false,
};

export default FormSubmitButtons;
